import { useEffect, useRef } from 'react';
export const useRunOnce = fn => {
  const triggered = useRef(false);
  useEffect(() => {
    if (!triggered.current) {
      fn();
      triggered.current = true;
    }
  }, [fn]);
  return null;
};
//# sourceMappingURL=useRunOnce.js.map